import { CampainInfo } from './Components/PaketSecim/type'

export type AccountCreateState = {
  generalInfo: any
  addressInfo: any
  adminUserInfo: any
  logoBase64?: string
  signatureBase64?: string
  eInvoiceTemplateBase64?: string
  eArchiveTemplateBase64?: string
  eSmmTemplateBase64?: string
  eInvoiceInfo: any
  eDespatchInfo: any
  eDespatchTemplateBase64?: string
  eDespatchAnswerTemplateBase64?: string
  eMmTemplateBase64?: string
  orderId: string
  campainCode?: string
  selectedPlanCode?: string
  callbackUrl?: string
  attachments: any[]
  dealerContract: {
    exist: boolean
    isSigning: boolean
    isQuerying: boolean
    fileName?: string
    signedContent?: string
    errorMessage?: string
    isVerified: boolean
  }
  campainContract: {
    exist: boolean
    isQuerying: boolean
    isSigning: boolean
    fileName?: string
    signedContent?: string
    errorMessage?: string
    isVerified: boolean
  }
  campainInfo?: CampainInfo

  currentStep: number
  stepInfoChecking: boolean
  stepInfoChecked: boolean
  dealerContractPageActive: boolean
  campainContractPageActive: boolean

  paymentInfo: {
    number: string
    name: string
    expiry: string
    cvc: string
    focused: string
  }
  payment3dsResponse?: {
    threeDSHtmlContent: string
  }
}

export enum ActionTypes {
  CREATE_ACCOUNT_REQUEST = '@@createAccount/CREATE_ACCOUNT_REQUEST',
  CREATE_ACCOUNT_FULFILLED = '@@createAccount/CREATE_ACCOUNT_FULFILLED',
  LAWYER_QUERY_REQUEST = '@@createAccount/LAWYER_QUERY_REQUEST_NOBLOCK',
  LAWYER_RESPONSE_CLEAR = '@@createAccount/LAWYER_RESPONSE_CLEAR',
  LAWYER_QUERY_FULFILLED = '@@createAccount/LAWYER_QUERY_FULFILLED',

  STEP_INFO_CHECK_REQUEST = '@@createAccount/STEP_INFO_CHECK_REQUEST_NOBLOCK',
  STEP_INFO_CHECK_FULFILLED = '@@createAccount/STEP_INFO_CHECK_FULFILLED',

  PREVIEW_DEALER_CONTRACT_REQUEST = '@@createAccount/PREVIEW_DEALER_CONTRACT_REQUEST_NOBLOCK',
  PREVIEW_DEALER_CONTRACT_FULFILLED = '@@createAccount/PREVIEW_DEALER_CONTRACT_FULFILLED',
  PREVIEW_DEALER_CONTRACT_REJECTED = '@@createAccount/PREVIEW_DEALER_CONTRACT_REJECTED',

  SIGN_DEALER_CONTRACT_REQUEST = '@@createAccount/SIGN_DEALER_CONTRACT_REQUEST_NOBLOCK',
  SIGN_DEALER_CONTRACT_FULFILLED = '@@createAccount/SIGN_DEALER_CONTRACT_FULFILLED',
  SIGN_DEALER_CONTRACT_REJECTED = '@@createAccount/SIGN_DEALER_CONTRACT_REJECTED',

  PREVIEW_CAMPAIN_CONTRACT_REQUEST = '@@createAccount/PREVIEW_CAMPAIN_CONTRACT_REQUEST_NOBLOCK',
  PREVIEW_CAMPAIN_CONTRACT_FULFILLED = '@@createAccount/PREVIEW_CAMPAIN_CONTRACT_FULFILLED',
  PREVIEW_CAMPAIN_CONTRACT_REJECTED = '@@createAccount/PREVIEW_CAMPAIN_CONTRACT_REJECTED',

  SIGN_CAMPAIN_CONTRACT_REQUEST = '@@createAccount/SIGN_CAMPAIN_CONTRACT_REQUEST_NOBLOCK',
  SIGN_CAMPAIN_CONTRACT_FULFILLED = '@@createAccount/SIGN_CAMPAIN_CONTRACT_FULFILLED',
  SIGN_CAMPAIN_CONTRACT_REJECTED = '@@createAccount/SIGN_CAMPAIN_CONTRACT_REJECTED',

  ON_CHANGE = '@@createAccount/ON_CHANGE',
  PAYMENT_3DS_FULLFILLED = '@@createAccount/PAYMENT_3DS_FULFILLED',
}
